import { getMapView } from "./arcgisUtils";

export const loadExtentFromUrl = () => {
    const mapView = getMapView();
    if (!mapView) return;

    const searchParams = new URLSearchParams(window.location.search);
    const x = searchParams.get("x");
    const y = searchParams.get("y");
    const scale = searchParams.get("scale");

    if (x) mapView.center.x = parseFloat(x);
    if (y) mapView.center.y = parseFloat(y);
    if (scale) mapView.scale = parseFloat(scale);

    return { x, y, scale };
};
